export default function Footer() {
  return (
    <footer id="footer" className="bg-background-50 border-t border-background-200/30">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center flex-shrink-0">
                <i className="ri-movie-2-fill text-foreground-950 text-lg"></i>
              </div>
              <span className="text-foreground-950 text-lg font-heading font-bold tracking-wide">
                8090影院
              </span>
            </div>
            <p className="text-foreground-500 text-sm leading-relaxed max-w-md">
              8090影院聚合免费电影大全资源，致力于为影迷提供高清电影在线观看体验。国内外大片全覆盖，不缓冲影院级播放，电影无广告干扰，海量影片随心点播。经典重温与最新热映，尽在8090影院。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-800 text-sm font-semibold mb-4 font-heading">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { href: '#carousel', label: '焦点专题' },
                { href: '#updates', label: '最新快讯' },
                { href: '#ranking', label: '热度榜单' },
                { href: '#faq', label: '常见问答' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-foreground-500 text-sm hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-foreground-800 text-sm font-semibold mb-4 font-heading">合作伙伴</h4>
            <p className="text-foreground-400 text-sm leading-relaxed">
              感谢各位合作伙伴的支持与信赖，共同打造优质观影生态。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/20 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-400 text-xs">
            &copy; {new Date().getFullYear()} 8090影院 版权所有 | 免费电影大全 · 高清电影在线 · 电影无广告
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-foreground-400 text-xs hover:text-primary-500 transition-colors cursor-pointer">回到顶部</a>
            <a href="#contact" className="text-foreground-400 text-xs hover:text-primary-500 transition-colors cursor-pointer">联系投稿</a>
          </div>
        </div>
      </div>
    </footer>
  );
}